import { Profile } from "app/helpers/globals";


export const tachosafeStagingProfile: Profile = {
    key: 'tachosafe-staging',
    domains: ['staging.tacho4safe.com', 'staging.tachosafe.net', 'staging.tacho5safe.com'],
    theme: 'tachosafe',
    apiUrl: (domain: string) => {
        return `https://api-${domain}/TachoSafe/`;
    },
    billingApiUrl: (domain: string) => {
        return `https://billing-${domain}/webProBilling`;
    },
    chartApiUrl: (domain: string) => {
        return `https://rszoft-report-${domain}/charts-generator-api/v0/`
    },
    i18nUrl: 'https://i18n.tacho5safe.com',
    i18nKey: 'tgpak_gvptiytqoe4ha4deonwdmzlonbrg23lhorsw23lbnaytg',
    disabledFeatures: [],
    topBarButtons: {
        more: true,
        help: true,
        phone: true,
        rduAdmin: true,
        rduManager: true,
        t2sUpdater: true,
        tachosafeSite: true,
        changesInStructure: true,
    },
    language: {
        fallback: 'en',
        default: 'en',
    },
    showAds: true,
    websiteTitle: '🟡 TS Staging 🟡',
    staticFiles: {
        logoColor: 'assets/profiles/tachosafe/newLogoColored.png',
        logoBlackAndWhite: 'assets/profiles/tachosafe/newLogo.png',
        favicon: 'assets/profiles/tachosafe/favicon.ico',
        backgroundImage: 'assets/profiles/tachosafe/Login Page_Background_2400x1600.webp',
    },
    documentLinks: {
        termsOfService: 'https://tachosafe.ro/terms-and-conditions',
        cookieNotice: 'https://tachosafe.ro/cookie-policy',
        privacyPolicy: 'https://tachosafe.ro/confidentiality-policy',
    },
    noDriverVehicleBanner: 'normal',
    disabledReports: [],
    forceShowScheduledReports: false,
};